import "./App.css";
import SigninSignup from "./signup-signin/signup-signin";

function App() {
  return (
    <div>
      <SigninSignup />
    </div>
  );
}

export default App;
